/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfGetUserForEditOutput } from "../models/AjaxResponseOfGetUserForEditOutput";
import type { AjaxResponseOfPagedResultDtoOfUserListDto } from "../models/AjaxResponseOfPagedResultDtoOfUserListDto";
import type { CreateOrUpdateUserInput } from "../models/CreateOrUpdateUserInput";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class UserAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns any Success
   * @throws ApiError
   */
  public createUser({
    requestBody,
  }: {
    requestBody?: CreateOrUpdateUserInput;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/users",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns AjaxResponseOfPagedResultDtoOfUserListDto
   * @throws ApiError
   */
  public getUsers({
    filter,
    permissions,
    role,
    onlyLockedUsers,
    sorting,
    maxResultCount,
    skipCount,
  }: {
    filter?: string;
    permissions?: Array<string>;
    role?: number;
    onlyLockedUsers?: boolean;
    sorting?: string;
    maxResultCount?: number;
    skipCount?: number;
  }): CancelablePromise<AjaxResponseOfPagedResultDtoOfUserListDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/users",
      query: {
        filter: filter,
        permissions: permissions,
        role: role,
        onlyLockedUsers: onlyLockedUsers,
        sorting: sorting,
        maxResultCount: maxResultCount,
        skipCount: skipCount,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public updateUser({
    requestBody,
  }: {
    requestBody?: CreateOrUpdateUserInput;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/users",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public deleteUser({ id }: { id?: number }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/users",
      query: {
        id: id,
      },
    });
  }

  /**
   * @returns AjaxResponseOfGetUserForEditOutput
   * @throws ApiError
   */
  public getUserById({
    id,
  }: {
    id: number;
  }): CancelablePromise<AjaxResponseOfGetUserForEditOutput> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/users/{id}",
      path: {
        id: id,
      },
    });
  }
}
